class HomeNewIn extends HTMLElement {
  constructor() {
    super();

    this.handleIntersection = this.handleIntersection.bind(this);
    this.observer = new IntersectionObserver(this.handleIntersection, {
      root: null, // Use the viewport as the root
      threshold: 0.1, // Trigger when 10% of the element is visible
    });
  }

  connectedCallback() {
    this.observer.observe(this); // Start observing the <home-new-in> element
    this.completeProductList();
  }

  async fetchSection(url) {
    const target = new URL(url, window.location.origin);
    if (target.origin !== window.location.origin) throw new Error('Invalid section origin');
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    const response = await fetch(target, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Section unavailable');
    return new DOMParser().parseFromString(await response.text(), 'text/html');
  }

  syncProductLists(first) {
    const lists = this.querySelectorAll('.home-new-in__list');
    if (lists.length > 1) lists[1].innerHTML = first.innerHTML;
  }

  async completeProductList() {
    if (this.completingProducts) return;
    this.completingProducts = true;
    const first = this.querySelector('.home-new-in__list');
    if (!first) return;
    try {
      const refresh = first.querySelector('[data-bl-just-in-refresh]');
      if (refresh) {
        const doc = await this.fetchSection(refresh.dataset.blJustInRefresh);
        const cleanList = doc.querySelector('.home-new-in__list');
        if (!cleanList || cleanList.querySelector('[data-bl-just-in-refresh]')) return;
        first.innerHTML = cleanList.innerHTML;
        this.syncProductLists(first);
      }
      const pending = first.querySelector('[data-bl-just-in-pending]');
      if (!pending) return;
      const urls = pending.dataset.blJustInPending.split('|').filter(Boolean);
      pending.remove();
      const seen = new Set(Array.from(first.querySelectorAll('.home-new-in__product-card'), item => item.getAttribute('href')));
      const visited = new Set();
      while (seen.size < 50 && urls.length && this.isConnected) {
        const url = urls.shift();
        if (visited.has(url)) continue;
        visited.add(url);
        const doc = await this.fetchSection(url);
        const page = doc.querySelector('[data-bl-just-in-page]');
        if (!page) break;
        for (const item of page.querySelectorAll('.home-new-in__product-item')) {
          const href = item.querySelector('.home-new-in__product-card')?.getAttribute('href');
          if (!href || seen.has(href)) continue;
          seen.add(href);
          first.appendChild(document.importNode(item, true));
          if (seen.size >= 50) break;
        }
        if (page.dataset.nextUrl) urls.unshift(page.dataset.nextUrl);
        this.syncProductLists(first);
      }
    } catch (error) {
      this.syncProductLists(first);
    }
  }

  disconnectedCallback() {
    this.observer.unobserve(this); // Stop observing when the element is removed
  }

  handleIntersection(entries, observer) {
    entries.forEach(entry => {
      const productsElement = this.querySelector('.home-new-in__products');
      if (!productsElement) return; // Exit if the element is not found

      if (entry.isIntersecting) {
        productsElement.classList.add('enable-animation');
      } else {
        productsElement.classList.remove('enable-animation');
      }
    });
  }
}

customElements.define('home-new-in', HomeNewIn);

